<script>
import StrWorker from '@/components/StrWorker.vue';
import PaySectionSelection from "@/components/PaySectionSelection.vue";
import useSharedData from "@/use/SharedData.js";
import useSharedMethod from "@/use/SharedMethod.js";
import {ref} from "vue";
import axios from "axios";

export default {
    props: {
        addAction: Boolean,
        deleteAction: Boolean,
    },
    components: {
        PaySectionSelection,
        StrWorker,
    },
    setup(props) {
        const {dialog, loading} = useSharedData();
        const {getBack} = useSharedMethod();

        const eraseOption = ref(false);
        const data = ref({
            workers: [],
            filter: {},
        });
        const paySections = ref([]);

        function save() {
            loading.value = true;
            const ids = data.value.workers.map((w) => w.id);
            const body = {
                ids: ids,
                paySections: paySections.value,
            };
            const url = props.addAction ? "addPaySections" : "deletePaySections";
            data.value.filter.eraseOption = eraseOption.value;
            axios.put(`/workers/${url}`, body, {
                params: data.value.filter,
            }).then(() => {
                getBack();
            }).finally(() => {
                loading.value = false;
            });
        }

        function updatePaySection(items) {
            paySections.value = items;
        }

        return {
            dialog,
            loading,
            eraseOption,
            data,
            paySections,
            save,
            getBack,
            updatePaySection
        }
    }
};
</script>

<template>
    <v-dialog
        transition="dialog-bottom-transition"
        v-model="dialog"
        persistent
        max-width="1500"
        scrollable
    >
        <v-card flat>
            <w-toolbar v-if="addAction" color="teal" :title="$t('common.add_pay_sections')"/>
            <w-toolbar v-if="deleteAction" color="red" :title="$t('common.delete_pay_sections')"/>
            <v-card-text>
                <StrWorker v-model="data" action="UPDATE_PAY_SLIP">
                    <pay-section-selection
                        :initial-pay-section-selection="paySections"
                        :by-occupation="false"
                        @updatePaySection="updatePaySection"
                    />
                </StrWorker>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-radio-group
                    v-model="eraseOption"
                    row
                    v-if="addAction"
                    class="ma-0 pa-0"
                    hide-details
                >
                    <template v-slot:label>
                        <div v-html="$t('common.if_pay_section_exist')"></div>
                    </template>
                    <v-radio
                        :value="false"
                        :label="$t('common.pay_section_erase_false')"
                        color="teal"
                    />
                    <v-radio
                        :value="true"
                        :label="$t('common.pay_section_erase_true')"
                        color="red"
                    />
                </v-radio-group>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn-add
                    :show="addAction"
                    :loading="loading"
                    @press="save"
                />
                <w-btn-delete
                    :show="deleteAction"
                    :loading="loading"
                    @press="save"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>